import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import BaseVehicleIcon from '#/shared/components/VehicleIcon';
import InfoIcon from '#/shared/components/GeneratedIcons/trimet/Info';
import {
  DESKTOP_MIN_BREAK,
  PHONE_BREAK,
  XSPHONE_BREAK,
  GTM_DATA_ATTRIBUTE,
} from '#/shared/constants';
import FrequentServiceIconBase from '#/shared/components/GeneratedIcons/trimet/FrequentService';
import FrequentExpressIconBase from '#/shared/components/GeneratedIcons/trimet/FrequentExpress';
import GTM_HANDLES from '#/shared/gtm-handles';
import { ClearButton } from '#/shared/components/Styled';

export const RouteDetailHeader = styled.div`
  display: flex;
  max-width: ${DESKTOP_MIN_BREAK};
  background-color: ${props => props.theme.inverseBackgroundColor2};
  color: ${props => props.theme.secondaryBackgroundColor};
  padding: 8px;
  flex-direction: column;
`;

export const RouteDetailRow = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const RouteDetailChildRow = styled.div`
  margin: 10px;
  @media (min-width: ${XSPHONE_BREAK}) {
    margin: 10px 40px;
  }
  @media (min-width: ${PHONE_BREAK}) {
    margin: 10px 60px;
  }

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    margin: 10px 8px;
  }
`;

export const RouteDetailHeaderIconColumn = styled.div`
  position: relative;
  flex: 0 1 125px;
  min-height: 85px;
  margin-right: 10px;
`;

export const RouteDetailHeaderNameColumn = styled.div`
  padding: 5px;
  flex: 1 1 auto;
`;

export const RouteDetailHeaderName = styled.div`
  font-size: 1.5em;
  line-height: 1.1em;
  margin-bottom: 10px;
`;

export const RouteDetailHeaderStopSummary = styled.div.attrs({
  role: 'heading',
  'aria-level': 2,
})`
  font-size: 1.2em;
`;

export const VehicleIcon = styled(BaseVehicleIcon).attrs({
  width: '90%',
  height: '90%',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const RouteBadgeWrapper = styled.div`
  position: relative;
  left: 10%;
  top: 10%;
`;

export const RouteFrequentServiceRow = styled.div.attrs({
  role: 'row',
})`
  flex: 1;
  display: flex;
  flex-direction: row;
  margin: 10px 0;
`;

export const FrequentServiceMessageColumn = styled.div`
  flex: 1;
  margin: 0 10px;
`;

export const FrequentServiceIconColumn = styled.div`
  flex: 0 0 auto;
  margin: 0 10px;
`;

export const FrequentServiceIcon = styled(FrequentServiceIconBase).attrs({
  role: 'presentation',
  width: 45,
  height: 45,
})``;

export const FrequentExpressIcon = styled(FrequentExpressIconBase).attrs({
  role: 'presentation',
  width: 45,
  height: 45,
})``;

export const RouteInfoIconButton = styled(ClearButton)`
  margin-left: 10px;
  opacity: 1;

  @media (any-hover: hover) {
    &:hover {
      cursor: pointer;
      opacity: ${props => props.theme.inactiveOpacity};
      background-color: transparent;
    }
  }
`;

export const RouteInfoIcon = injectIntl(styled(InfoIcon).attrs(
  ({ intl, ...props }) => ({
    fill: props.theme.secondaryBackgroundColor,
    height: 14,
    width: 14,
    title: intl.formatMessage({ id: 'routes.fullroutedetails_link' }),
    role: 'link',
    [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.route.fullRouteDetailsButton,
  })
)`
  flex-shrink: 0;
`);
